namespace SorAraBul.Administration {

    @Serenity.Decorators.registerClass()
    export class PurchasePackageFeaturesEditorDialog extends Serenity.Extensions.GridEditorDialog<PurchasePackageFeaturesRow> {
        protected getFormKey() { return PurchasePackageFeaturesForm.formKey; }
        protected getLocalTextPrefix() { return PurchasePackageFeaturesRow.localTextPrefix; }
        protected getNameProperty() { return PurchasePackageFeaturesRow.nameProperty; }

        protected form = new PurchasePackageFeaturesForm(this.idPrefix);
    }
}
